import { merge } from '../../../../utils/state';
import { TYPES } from './actions';

const initialState = {
  creatorProfile: {
    data: {},
    error: null,
    isLoading: false,
  },
  filterOptions: {},
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPES.GET_CREATOR_PROFILE:
      return merge(state, {
        creatorProfile: {
          ...state.creatorProfile,
          data: {},
          error: null,
          isLoading: true,
        },
      });
    case TYPES.GET_CREATOR_PROFILE_SUCCESS:
      return merge(state, {
        creatorProfile: {
          ...state.creatorProfile,
          data: action.payload,
          isLoading: false,
        },
      });
    case TYPES.GET_CREATOR_PROFILE_ERROR:
      return merge(state, {
        creatorProfile: {
          ...state.creatorProfile,
          data: {},
          error: action.payload,
          isLoading: false,
        },
      });
    case TYPES.UPDATE_FILTER_OPTIONS:
      return merge(state, {
        filterOptions: action.payload,
      });
    default:
      return state;
  }
};

export default reducer;
